import EmergencyTrigger from "../../components/EmergencyTrigger";
import MapView from "../../components/MapView";
import AlertFeed from "../../components/AlertFeed";
import StatsPanel from "../../components/StatsPanel";
import ProximitySettings from "../../components/ProximitySettings";
import EscalationPanel from "../../components/EscalationPanel";
import DrivingModeToggle from "../../components/DrivingModeToggle";
import SafeRoutePanel from "../../components/SafeRoutePanel";
import DashboardDigestCTA from "../../components/DashboardDigestCTA";
import LocationStatus from "./LocationStatus";

export default function DesktopLayout({
  user,
  isAdmin,
  alerts,
  userLocation,
  stats,
  proximityRadius,
  updateProximity,
  setManualLocation,
  retryGPS,
  wsConnected,
  driving,
  recommendedRoute,
  setRecommendedRoute,
  trackingSessions,
  focusLocation,
  focusAlertId,
  onMarkerFocus,
  onTrigger,
  onResolve,
  onAssign,
  onDelete,
  onVote,
  onAlertFocus,
}) {
  return (
    <main className="hidden lg:grid lg:grid-cols-12 h-[calc(100vh-56px)]">
      <div className="lg:col-span-2 border-r border-gray-200 bg-white p-4 overflow-y-auto">
        <EmergencyTrigger onTrigger={onTrigger} />
        <div className="mt-3 mb-3" data-testid="driving-mode-desktop">
          <DrivingModeToggle
            enabled={driving.enabled}
            onToggle={driving.toggle}
            trackedSince={driving.trackedSince}
            currentSpeedKph={driving.currentSpeedKph}
          />
        </div>
        {driving.enabled && (
          <div className="mb-3" data-testid="safe-route-desktop-slot">
            <SafeRoutePanel
              userLocation={userLocation}
              onRecommendedRoute={setRecommendedRoute}
            />
          </div>
        )}
        <StatsPanel stats={stats} />
        <ProximitySettings radius={proximityRadius} onUpdate={updateProximity} />
        {isAdmin && <EscalationPanel />}
        {isAdmin && <DashboardDigestCTA user={user} />}
        <LocationStatus location={userLocation} onRetry={retryGPS} wsConnected={wsConnected} />
      </div>
      <div className="lg:col-span-7 border border-gray-900">
        <MapView
          alerts={alerts}
          userLocation={userLocation}
          proximityRadius={proximityRadius}
          onLocationSet={setManualLocation}
          focusLocation={focusLocation}
          focusAlertId={focusAlertId}
          onMarkerFocus={onMarkerFocus}
          trackingSessions={trackingSessions}
          recommendedRoute={recommendedRoute}
        />
      </div>
      <div className="lg:col-span-3 border-l border-gray-200 bg-white">
        <AlertFeed
          alerts={alerts}
          onResolve={onResolve}
          onAssign={isAdmin ? onAssign : null}
          onDelete={isAdmin ? onDelete : null}
          onVote={onVote}
          onFocus={onAlertFocus}
          focusAlertId={focusAlertId}
          user={user}
        />
      </div>
    </main>
  );
}
